<template>
  <div class="contents">
    <top></top>
    <div class="order-list">
      <div class="search">
        <div class="search_l">
          <el-select
            @change="getOrderList(1)"
            v-model="queryParams.type"
            prefix-icon="el-icon-search"
            style="margin-right: 10px"
            size="small"
            clearable
            placeholder="订单类型"
            placeholder-class="placeholder_text"
          >
            <el-option label="订阅套餐" :value="1"> </el-option>
            <el-option label="套餐续费" :value="2"> </el-option>
            <el-option label="购买席位" :value="3"> </el-option>
            <el-option label="订单审控" :value="0"> </el-option>
            <el-option label="扩展内容" :value="4"> </el-option>
          </el-select>
          <el-select
            @change="getOrderList(1)"
            v-model="queryParams.status"
            prefix-icon="el-icon-search"
            style="margin-right: 10px"
            size="small"
            clearable
            placeholder="订单状态"
            placeholder-class="placeholder_text"
          >
            <el-option label="进行中" :value="0"> </el-option>
            <el-option label="已完成" :value="1"> </el-option>
            <el-option label="已取消" :value="2"> </el-option>
          </el-select>
          <el-date-picker
            @change="handleDate"
            v-model="date"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
          >
          </el-date-picker>
        </div>
        <div class="search_r">
          <el-input
            @change="getOrderList(1)"
            placeholder="请输入订单编号"
            prefix-icon="el-icon-search"
            size="small"
            clearable
            v-model="queryParams.pid"
            @input="inputOrder"
          >
          </el-input>
        </div>
      </div>
      <div class="table_box">
        <el-table :data="orderList" v-loading="loading" height="100%">
          <el-table-column label="订单编号" prop="pid" width="150"></el-table-column>
          <el-table-column label="订单金额" prop="amount"></el-table-column>
          <el-table-column label="订单类型" prop="type">
            <template #default="scope">
              <el-tag v-if="scope.row.type == 1" size="small">订阅套餐</el-tag>
              <el-tag v-else-if="scope.row.type == 2" size="small">套餐续费</el-tag>
              <el-tag v-else-if="scope.row.type == 3" size="small">购买席位</el-tag>
              <el-tag v-else-if="scope.row.type == 0" size="small">订单审控</el-tag>
              <el-tag v-else size="small">扩展内容</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="订单状态" prop="status">
            <template #default="scope">
              <el-tag v-if="scope.row.status == 0" type="warning" size="small">进行中</el-tag>
              <el-tag v-else-if="scope.row.status == 1" type="success" size="small">已完成</el-tag>
              <el-tag v-else-if="scope.row.status == 2" type="danger" size="small">已取消</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="说明" prop="packageInfo" width="300" show-overflow-tooltip></el-table-column>
          <el-table-column label="创建时间" prop="createTime" width="160"></el-table-column>
          <el-table-column label="操作" width="150">
            <template #default="scope">
              <el-link
                v-if="scope.row.status == 0"
                type="primary"
                :underline="false"
                @click="handlePay(scope.row)"
                style="margin-right: 10px"
                >去支付</el-link
              >
              <el-link
                v-if="scope.row.status == 0"
                type="primary"
                :underline="false"
                @click="handleCloseOrder(scope.row)"
                >关闭订单</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="table-pagination">
        <el-pagination
          background
          class="penye"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog title="待支付" @opened="handleOpen" @closed="handleClose" :visible.sync="dialogVisible" width="30%">
      <div class="dialog-form">
        <div class="form-item" style="justify-content: center">
          <div class="form-accmount">
            <div class="accmount-tl">支付金额</div>
            <div class="accmount-num">$ {{ rowData.amount }}</div>
            <div class="accmount-text">
              剩余支付时间：
              <span class="accmount-text-date">{{ timeText }}</span>
            </div>
          </div>
        </div>
        <div class="form-item" style="justify-content: center">
          <div class="content" style="width: 50%">
            <img style="width: 100%" :src="rowData.qrCode" alt="" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">收款地址</div>
          <div class="content">{{ rowData.address || "--" }}</div>
        </div>
        <div class="form-item">
          <div class="label">支付方式</div>
          <div class="content">
            <span>{{ rowData.paymentMethod || "--" }}</span>
          </div>
        </div>
        <div class="form-item">
          <div class="label">订单编号</div>
          <div class="content">
            <span>{{ rowData.cid || "--" }}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" class="order-btn">已支付</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import top from "./components/top.vue";
export default {
  data() {
    return {
      loading: false,
      orderList: [],
      date: [],
      dialogVisible: false,
      rowData: {},
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        startTime: null,
        endTime: null,
        status: null,
        type: null,
        pid: null,
      },
      total: 0,
      now: Date.now(),
      timer: null,
    };
  },
  mounted() {
    this.getOrderList();
  },
  computed: {
    timeText() {
      const end = new Date(this.rowData.expirationTime).getTime();
      let diff = end - this.now;

      if (diff <= 0) {
        return "00:00:00";
      }

      const totalSeconds = Math.floor(diff / 1000);

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return (
        String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0")
      );
    },
    roles() {
      return this.$store.state.userStore.roles;
    },
  },
  watch: {
    timeText(newValue, oldValue) {
      if (newValue == "00:00:00") {
        this.$message({
          type: "warning",
          message: "订单已过期",
        });
        setTimeout(() => {
          this.dialogVisible = false;
        }, 1000);
        this.orderClose(this.rowData.id)
      }
    },
  },
  components: {
    top,
  },
  methods: {
    inputOrder(val) {
      const onlyNum = val.replace(/\D/g, "");
      this.queryParams.pid = onlyNum;
    },
    handleDate(e) {
      if (e) {
        this.queryParams.startTime = e[0];
        this.queryParams.endTime = e[1];
        this.getOrderList(1);
      } else {
        this.queryParams.startTime = null;
        this.queryParams.endTime = null;
        this.getOrderList(1);
      }
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getOrderList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getOrderList();
    },
    getOrderList(val) {
      this.loading = true;
      if (val == 1) {
        this.queryParams.pageNum = 1;
      }
      this.$http({
        url: "/customer/transactionBuyList",
        method: "POST",
        data: this.queryParams,
      })
        .then((res) => {
          this.orderList = res.rows;
          this.total = res.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handlePay(row) {
      this.rowData = JSON.parse(row.packageJson);
      Object.assign(this.rowData, {
        id: row.id,
        cid: row.cid,
        amount: row.amount,
        expirationTime: row.expirationTime,
      });
      this.dialogVisible = true;
    },
    handleOpen() {
      this.now = Date.now();
      this.timer = setInterval(() => {
        this.now = Date.now();
      }, 1000);
    },
    handleClose() {
      this.rowData = {};
      this.timer && clearInterval(this.timer);
    },
    handleCloseOrder(row) {
      this.$confirm("你确认要取消该支付订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.orderClose(row.id);
      });
    },
    orderClose(id) {
      this.$http({
        url: "/customer/cancelOrder",
        method: "POST",
        data: { id },
      }).then(() => {
        this.$message({
          type: "success",
          message: "订单已取消",
        });
        this.getOrderList(1);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.contents {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.order-list {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  flex-shrink: 0;
}

.search_l {
  display: flex;
  justify-content: flex-start;
  width: 60%;
}

.search_r {
  width: 30%;
}

.table_box {
  width: 99%;
  height: 100%;
}

.table-button {
  margin-right: 10px;
  font-size: 20px;
}

.table-pagination {
  flex-shrink: 0;
  text-align: right;
  padding-top: 20px;
}

.topOrder {
  text-align: right;
  cursor: pointer;
}

.dialog-form {
  display: flex;
  flex-direction: column;
  .form-item {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .label {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .tip {
        font-size: 12px;
        color: #999999;
      }
    }
    .content {
      display: flex;
      align-items: center;
      .con-img {
        width: 100%;
      }
    }
    .form-accmount {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: default;
      .accmount-num {
        color: #333;
        font-weight: bold;
        font-size: 30px;
        padding: 10px 0;
      }
      .accmount-text-date {
        font-weight: bold;
        font-size: 18px;
        color: #d35846;
      }
    }
  }
}
.order-btn {
  width: 100%;
}
.num {
  font-weight: bold;
  color: #333333;
  font-size: 18px;
}
.error {
  color: red;
  margin-left: 10px;
  font-size: 13px;
}
</style>
